import L from 'leaflet';
import Vue from 'vue';
import Control from '../leaflet-controls/control';
import heatmapLegendVue from '../../components/map/heatmap-legends'

export default Control.extend({
  heatmaps: [],
  options: {
    position: 'topleft',
    show: false
  },
  onAdd: function() {
    this.options.show = true
    this.container = L.DomUtil.create('div')
    this.subcontainer = L.DomUtil.create('div')
    this.container.appendChild(this.subcontainer)

    L.DomEvent.disableClickPropagation(this.container)
    L.DomEvent.disableScrollPropagation(this.container)

    return this.container
  },
  mounted () {
    const HeatmapLegendClass = Vue.extend(heatmapLegendVue)
    this._heatmap = new HeatmapLegendClass({
      propsData: {
        map: this._map
      }
    })

    this._heatmap.$vuetify = this.options.vue.$vuetify
    this._heatmap.$store = this.options.vue.$store
    this._heatmap.$mount(this.subcontainer)
  },
  addHeatmap (data) {
    const index = this.heatmaps.findIndex(val => val.id === data.id)
    if (index === -1) {
      this.heatmaps.push(data)
      this._heatmap.addHeatmap(data)
    } else {
      this._heatmap.updateHeatmap(index, data)
    }
  },
  removeHeatmap (data) {
    this.heatmaps = this.heatmaps.filter(val => val.id !== data.id)
    if (this.heatmaps.length === 0) {
      this.remove()
    } else {
      this._heatmap.removeHeatmap(data)
    }
  },
  onRemove: function () {
    this.options.show = false
    this._heatmap.$destroy()
  }
})
